var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "wrap", staticClass: "artboards" }, [
    _c("canvas", {
      ref: "canvas",
      staticClass: "artboards__canvas",
      on: {
        mousemove: _vm.onMove,
        mouseleave: _vm.onLeave,
        click: _vm.onClick,
      },
    }),
    _vm._v(" "),
    _vm.tooltip.visible
      ? _c(
          "div",
          { staticClass: "artboards__tooltip", style: _vm.tooltipStyle },
          [_vm._v("\n    " + _vm._s(_vm.tooltip.text) + "\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }